import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "onClick"]

import { RouteLocationRaw } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    title: {},
    to: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    custom: "",
    to: props.to
  }, {
    default: _withCtx(({ isActive, href, navigate }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["header-menu__item", { 'header-menu__item_state_active': isActive }])
      }, [
        _createElementVNode("a", {
          href: href,
          onClick: navigate
        }, _toDisplayString(props.title), 9, _hoisted_1)
      ], 2)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})